import React from 'react';

import { PageWithSidebar } from '@vlabs/uikit';

import { SelectedEventEmptyState } from './SelectedEventEmptyState';
import { DetectionAndMatchEventView } from '../detection-and-match-event/DetectionAndMatchEventView';
import {
  EVENT_ROLL_SIDEBARS as SIDEBARS,
} from '../event-roll/EventRoll.js';
import type { SidebarName } from '../event-roll/EventRoll.js';
import WorkspaceFiltersPanel from '../filters/WorkspaceFiltersPanel';
import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent.js';

interface SelectedEventViewProps {
  activeSidebar: SidebarName | null;
  onToggleSidebar: (name: SidebarName) => void;
}

export function SelectedEventView({
  activeSidebar,
  onToggleSidebar,
}: SelectedEventViewProps): React.JSX.Element {
  const { isEvent, selectedEventId } = useSelectedWorkspaceEvent();

  return (
    <PageWithSidebar
      isOpenLeftSidebar={!!activeSidebar}
      leftSidebar={(
        <React.Fragment>
          {activeSidebar === SIDEBARS.FILTERS && (
            <WorkspaceFiltersPanel
              key="filters"
              onCloseClick={() => onToggleSidebar('filters')}
            />
          )}
        </React.Fragment>
      )}
      mode="overlay"
    >
      {!!isEvent && !!selectedEventId && <DetectionAndMatchEventView />}

      {!selectedEventId && <SelectedEventEmptyState />}
    </PageWithSidebar>
  );
}
